/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=new WeakMap,t=new WeakMap,n=t=>{const n=e.get(t.target);n&&n(t)},o=e=>{e.forEach(n)};function r(n,r,s){const c=function({root:e,...n}){const r=e||document;t.has(r)||t.set(r,{});const s=t.get(r),c=JSON.stringify(n);return s[c]||(s[c]=new IntersectionObserver(o,{root:e,...n})),s[c]}(r);return e.set(n,s),c.observe(n),()=>{e.delete(n),c.unobserve(n)}}export{r as observeIntersection};
//# sourceMappingURL=observers.js.map
